import * as React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TransformYourSpace() {
  return <section data-section-id="221448" id="մեր-մասին-հերո" className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background !bg-[url('https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/geocosmos_mission_control_orbital.png') bg-cover bg-center bg-no-repeat">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px]" />
      <div className="relative z-10 flex w-full max-w-7xl flex-col items-center justify-center px-4 text-center">
        <h1 className="font-default mb-8 leading-[0.85] tracking-tighter text-foreground drop-shadow-2xl uppercase !text-8xl">
          Դիտում ենք տիեզերքից, գործում երկրի վրա
        </h1>
              <p className="leading-relaxed text-muted-foreground font-serif !text-2xl !w-[950px] !text-justify">
                Տիեզերքի նվաճումը սկսվում է հստակ տվյալներից և նորարարական մտածողությունից։ Հայաստանն այսօր լիիրավ մասնակիցն է տիեզերական հեղափոխության։
              </p>
        <Button asChild size="lg" className="group relative h-auto overflow-hidden rounded-md bg-primary px-10 py-6 font-default text-2xl uppercase tracking-widest text-primary-foreground shadow-xl transition-all duration-300 hover:-translate-y-1 hover:scale-105 hover:bg-primary/90 md:px-14 md:py-8 md:text-3xl">
        </Button>
      </div>
      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 animate-pulse">
        <ChevronDown className="h-12 w-12 text-primary drop-shadow-md" strokeWidth={1.5} />
      </div>
    </section>;
}